import {useSelector} from "react-redux";
import {selectCurrentToken} from "./authSlice";
import {Navigate, useLocation} from "react-router-dom";

const CheckAuth = () => {
    const token = useSelector(selectCurrentToken)
    const location = useLocation();


    return(
        token
            ? <Navigate to="/panel" state={{from: location}} replace />
            : <Navigate to="/login" state={{from: location}} replace />
    )
}

export default CheckAuth;